export default __webpack_public_path__ + "images/0x25ea98ac87a38142561ea70143fd44c4772a16b6.png";